import { render } from "./BranchPlaceBindList.vue?vue&type=template&id=631f23ff"
import script from "./BranchPlaceBindList.vue?vue&type=script&lang=js"
export * from "./BranchPlaceBindList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__